<template>
  <div>
    <title>Mandelbrot Explorer</title>
    <div class="title"> Mandelbrot Set Explorer </div>
    <div class="date"> August 17th, 2019 </div>

    <div id="container" style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: #222222;">
        <div id="help" style="font: 14px monospace; padding: 15px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: rgba(29, 28, 25, 0.7); border-radius: 5px; color: white">
            <p style="margin: 0 0; font-size: large;">Mandelbrot Explorer</p>
            <p style="text-align: left;"> 
                • Save the image by right clicking the screen -> "Save image as... " <br/>
                • To zoom into the mandelbrot by clicking and dragging the mouse 
            </p>
            <img style="display: block; margin: 0 auto" src="static/mandelbrot/fractal_help.png" alt="help picture">
            <button id="help_btn" style="background-color: #24231f; float: right; border: none; border-radius: 5px; font: 14px monospace; padding: 7px 16px; text-align: center; text-decoration: none; color: white">Ok</button>
        </div>

        <div id="progressContainer" style="position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0; text-align: center; bottom: 10px; z-index: 1000;">
            <div id="progressText" style="font: 14px monospace; color: white;">Computing... 0%</div>
            <progress id="progressBar" max="100" value="70" style="color:white"></progress>
        </div>
        <div id="rect" style="position: absolute; border: 1px solid red; display: none; color: white; z-index: 1000;"></div>
        <canvas id="canvas" width="100%" height="100%"></canvas>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Mandelbrot Explorer',
  mounted: () => {
      do_js();
  }
}

function do_js() {
var help = document.getElementById("help");
var help_btn = document.getElementById("help_btn");
help_btn.addEventListener("mousedown", (event) => {
    event.stopImmediatePropagation();
});
help_btn.addEventListener("mouseup", (event) => {
    help.style.display = "none";
    event.stopImmediatePropagation();
});
help.addEventListener("mousedown", (event) => {
    event.stopImmediatePropagation();
})
help.addEventListener("mouseup", (event) => {
    event.stopImmediatePropagation();
})

var progress_container = document.getElementById("progressContainer");
var progress_bar = document.getElementById("progressBar");
var progress_text = document.getElementById("progressText");

function set_progress(percentage) {
    function zero_pad(number, max_length) {
        number = number.toString();
        while (number.length < max_length)
            number += "0";
        return number;
    }
    progress_container.style.display = "block";
    // percentage should be between 0 and 1.0
    progress_bar.value = progress_bar.max * percentage;
    progress_text.innerHTML = `Computing mandelbrot... ${zero_pad((100 * percentage).toPrecision(4), 5)}%`;
}


var container = document.getElementById("container");
var rect = document.getElementById("rect");
var mouse_x = undefined;
var mouse_y = undefined;
container.addEventListener("mousedown", (event) => {
    // Was not left click
    if (event.button != 0)
        return
        
    mouse_x = event.clientX;
    mouse_y = event.clientY;
    rect.style.display = "block";
    rect.style.top = `${mouse_y}px`;
    rect.style.height = `1px`;
    rect.style.left = `${mouse_x}px`;
    rect.style.width = `1px`;
});
container.addEventListener("mousemove", (event) => {
    if (mouse_x === undefined || mouse_y === undefined)
        return;
    
    rect.style.top = `${Math.min(event.clientY, mouse_y)}px`;
    rect.style.height = `${Math.abs(event.clientY - mouse_y)}px`;
    rect.style.left = `${Math.min(event.clientX, mouse_x)}px`;
    rect.style.width = `${Math.abs(event.clientX - mouse_x)}px`;
});
container.addEventListener("mouseup", (event) => {
    if (event.button != 0 || mouse_x === undefined || mouse_y === undefined)
        return
    let left = Math.min(event.clientX, mouse_x);
    let right = left + Math.abs(event.clientX - mouse_x);
    let top = Math.min(event.clientY, mouse_y);
    let bottom = top + Math.abs(event.clientY - mouse_y);
    let new_min_x = get_linear_scale(min_x, max_x, left / canvas.offsetWidth);
    let new_max_x = get_linear_scale(min_x, max_x, right / canvas.offsetWidth);
    let new_min_y = get_linear_scale(min_y, max_y, top / canvas.offsetHeight);
    let new_max_y = get_linear_scale(min_y, max_y, bottom / canvas.offsetHeight);
    min_x = new_min_x;
    max_x = new_max_x;
    min_y = new_min_y;
    max_y = new_max_y;

    mouse_x = undefined;
    mouse_y = undefined;
    rect.style.display = "none";
    generate_mandelbrot();
});

var canvas = document.getElementById("canvas");
canvas.style.width  = '100%';
canvas.style.height = '100%';
canvas.width  = canvas.offsetWidth;
canvas.height = canvas.offsetHeight;
var cx = canvas.getContext("2d");

var image = cx.createImageData(canvas.offsetWidth, canvas.offsetHeight);
console.log(image.data)

class Complex {
    constructor(real, imaginary) {
        this.r = real;
        this.i = imaginary
    }

    static get zero() {
        return new Complex(0, 0);
    }

    static get one() {
        return new Complex(1, 0);
    }

    static get i() {
        return new Complex(0, 1);
    }

    static polar(magnitude, angle) {
        return new Complex(magnitude * Math.cos(angle), magnitude * Math.sin(angle));
    }

    get angle() {
        return Math.atan2(this.i, this.r);
    }

    get magnitude() {
        return (this.r**2 + this.i**2)**0.5;
    }

    add(complex) {
        return new Complex(this.r + complex.r, this.i + complex.i);
    }

    subtract(complex) {
        return new Complex(this.r - complex.r, this.i - complex.i);
    }

    multiply(complex) {
        return new Complex(this.r * complex.r - this.i * complex.i, this.r * complex.i + this.i * complex.r);
    }

    divide(complex) {
        let m = complex.r**2 + complex.i**2;
        if (m == 0)
            throw "You cannot divide a complex number by zero";
        return new Complex(
            (this.r * complex.r + this.i * complex.i) / m, 
            (this.i * complex.r - this.r * complex.i) / m
        );
    }

    pow(complex) {
        let m = this.magnitude;
        if (m == 0)
            return Complex.zero;
        let theta = this.angle;
        return Complex.polar(
            Math.exp(complex.r * Math.log(m) - complex.i * theta),
            complex.r * theta - complex.i * Math.log(m)
        );
    }
}
Complex.prototype.toString = function() { return `${this.r} + ${this.i}i`; };

function set_pixel(x, y, color) {
    if (color.length != 4)
        throw color.toString() + " is not an ARGB array of length 4";

    for (let n = 0; n < 4; n++) 
        image.data[(y * canvas.offsetWidth + x) * 4 + n] = color[n];
}

function get_color_scale(c1, c2, scale) {
    if (c1.length != c2.length)
        throw c1.toString() + " is not the same length as " + c2.toString();

    let result = [];
    for (let i = 0; i < c1.length; i++)
        result.push(Math.floor( c1[i] + (c2[i] - c1[i]) * scale ));
    return result;
}

function get_linear_scale(start, end, scale) {
    return start + (end - start) * scale;
}

const num_iterations = 100;
function mandelbrot(c) {
    let z = new Complex(0, 0);
    for (let i = 0; i < num_iterations; i++) {
        z = z.pow(new Complex(2, 0)).add(c);
        if (z.magnitude > 2) 
            return i / num_iterations;
    }
    return 1;
}

const black = [0, 0, 0, 255];
const white = [100, 100, 100, 255];
const maintain_ratio = true;
var min_x = -0.5;
var max_x = 0.5;
var min_y = -1;
var max_y = 1;
function generate_mandelbrot() {
    if (maintain_ratio && canvas.offsetWidth >= canvas.offsetHeight) {
        let middle = (max_x + min_x) / 2;
        let offset = (canvas.offsetWidth) * (max_y - min_y) / (2 * canvas.offsetHeight);
        min_x = middle - offset;
        max_x = middle + offset;
    }
    if (maintain_ratio && canvas.offsetWidth < canvas.offsetHeight) {
        let middle = (max_y + min_y) / 2;
        let offset = (canvas.offsetHeight) * (max_x - min_x) / (2 * canvas.offsetWidth);
        min_y = middle - offset;
        max_y = middle + offset;
    }
    console.log(`${min_x} < x < ${max_x}; ${min_y} < y < ${max_y}`);

    let complete = false;
    for (let y = 0; y < canvas.offsetHeight; y += 1) {
        setTimeout(() => {
            for (let x = 0; x < canvas.offsetWidth; x += 1) {
                let x_scale = x / canvas.offsetWidth;
                let y_scale = y / canvas.offsetHeight;
                let z = new Complex(get_linear_scale(min_x, max_x, x_scale), get_linear_scale(min_y, max_y, y_scale));
                let fractal_result = mandelbrot(z);
                let c = get_color_scale(black, white, fractal_result);
                set_pixel(x, y, c);
            }
            
            if (y + 1 >= canvas.offsetHeight)
                complete = true;
        }, 0);
            
        setTimeout(() => {
            set_progress(y / canvas.offsetHeight);
        }, 0);
    }

    setTimeout(() => {
        while (!complete) {
            // spin
        }
        cx.putImageData(image, 0, 0);
        set_progress(1);
        progress_container.style.display = "none";
    })
}
generate_mandelbrot();
}
</script>